import classNames from 'classnames';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface TableHeaderProps {
  header: string[];
  headerClassName?: string;
}

const _TableHeader = ({ header, headerClassName }: TableHeaderProps) => {
  const { t } = useTranslation();

  return (
    <>
      {header?.map((param: string) => (
        <th
          key={param}
          className={classNames(
            'font-bold text-xs text-wthap_table_text bg-wthap_table_header_bg py-2.5 bonusTableHeader text-start first:!pl-[5px]',
            headerClassName
          )}>
          {t(param)}
        </th>
      ))}
    </>
  );
};

export const TableHeader = memo(_TableHeader);
